import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '1086781087036952';
interface AppProps {
  showSocialProofPopups?: boolean;
}
export function App({
  showSocialProofPopups = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nxwv3et6z8sj">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="sudmqizlo5ad" />
      </noscript>
      <div className="min-h-screen w-full bg-brand-cream text-brand-ink overflow-x-hidden" data-id="element-2" data-mp="3ubzw6hji5vht">
        {showSocialProofPopups && <UrgencyBanner data-id="element-3" data-mp="d3wa4yp812pu" />}
        <main data-id="element-4" data-mp="85l28tihl2a9">
          <Hero data-id="element-5" data-mp="851l3f0nuhxa" />
          <PainSection data-id="element-6" data-mp="86mfn4mz60v5" />
          <SystemSection data-id="element-7" data-mp="8649ngaig8a1" />
          <BonusSection data-id="element-8" data-mp="83qi3hf1he78" />
          <PricingCard data-id="element-9" data-mp="3gkv0fqj99ncr" />
          <Guarantee data-id="element-10" data-mp="3gmft1am0ew7z" />
          <Testimonials data-id="element-11" data-mp="3glo067jsrcle" />
          <FAQ data-id="element-12" data-mp="3gj1w4hw47f7x" />
          <FinalCTA data-id="element-13" data-mp="3bmjrrj4p5iw4" />
        </main>
        <Footer data-id="element-14" data-mp="3bnmfji6q357t" />
      </div>
    </>;
}